var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16667 17.7499C1.70833 17.7499 1.31583 17.5869 0.989168 17.2608C0.662501 16.9346 0.499446 16.5421 0.500001 16.0833V4.41659C0.500001 3.95825 0.663335 3.56575 0.990001 3.23909C1.31667 2.91242 1.70889 2.74936 2.16667 2.74992H9.60417L7.9375 4.41659H2.16667V16.0833H13.8333V10.2916L15.5 8.62492V16.0833C15.5 16.5416 15.3367 16.9341 15.01 17.2608C14.6833 17.5874 14.2911 17.7505 13.8333 17.7499H2.16667ZM11.4792 3.22909L12.6667 4.39575L7.16667 9.89575V11.0833H8.33333L13.8542 5.56242L15.0417 6.72909L9.04167 12.7499H5.5V9.20825L11.4792 3.22909ZM15.0417 6.72909L11.4792 3.22909L13.5625 1.14575C13.8958 0.812419 14.2953 0.645752 14.7608 0.645752C15.2264 0.645752 15.6186 0.812419 15.9375 1.14575L17.1042 2.33325C17.4236 2.6527 17.5833 3.04159 17.5833 3.49992C17.5833 3.95825 17.4236 4.34714 17.1042 4.66659L15.0417 6.72909Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.21c5068619bb38fa0eeed12bf0d2d279.svg";
export { ForwardRef as ReactComponent };